import QcVerdictFlow from '@/components/marketing/technology/QcVerdictFlow'
import TechnologySubPage from '@/components/marketing/technology/TechnologySubPage'
import type { TechnologySubPageProps } from '@/types/technology'

/* The technology section — the Release QC page.
 *
 * All the sub-pages share one layout and differ only in the props
 * TechnologyController builds from TechnologyContent. This file exists because
 * the marketing entrypoint resolves `render inertia: "technology/Qc"` against
 * this exact path — it is the route, not a place for page-specific markup.
 *
 * ONE visual (owner, 2026-10-18 — the page used to open with two widgets).
 * The verdict model carries the idea that has to land first: a fifth outcome
 * between pass and fail. The clarification loop that runs on it is in build,
 * and its card's badge says so.
 */
export default function Qc(props: TechnologySubPageProps) {
  return <TechnologySubPage {...props} visual={<QcVerdictFlow />} />
}
